import React from "react";
import useScrollAnimation from "../../hooks/useScrollAnimation";
export default function Map() {
    useScrollAnimation();
    return (
        <section className="relative py-[40px]">
            <div className="main-title js-scroll fade-top">
                <div>always with you</div>
            </div>
            <div className="backMap flex items-center justify-center">
                <img className="w-100 js-scroll fade-btm w-[60%] h-full" src={require("../../assets/image/map.svg").default} alt="" />
            </div>
        </section>
    );
}